import { byokFetch } from "./client";
import type { ByokKey } from "../types";

export async function listByokKeys(): Promise<ByokKey[]> {
  return byokFetch<ByokKey[]>("byok-keys", "", { method: "GET" });
}
